import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Calendar, ExternalLink, Award, Building, Briefcase, Users } from 'lucide-react';

export const News = () => {
  const news = [
    {
      id: 1,
      title: "Grand Prix de la Meilleure Entreprise Immobilière",
      date: "15 Juillet 2025",
      category: "Récompense",
      icon: Award,
      color: "#FFB81C",
      image: "https://customer-assets.emergentagent.com/job_ekip-showcase/artifacts/j4nduvfj_Article%20Presse.jpg",
      pressRelease: null,
      pressArticles: [
        {
          title: "Article de Presse - La Voie Ordinale",
          image: "https://customer-assets.emergentagent.com/job_ekip-showcase/artifacts/8t2te4db_Article%20de%20presse.jpg"
        }
      ],
      onlineArticles: [
        {
          title: "Le Mandat Express - Ouagnimin Sorho primé pour son engagement",
          url: "https://www.lemandatexpress.net/2025/07/11/ouagnimin-sorho-prime-pour-son-engagement-en-faveur-dun-immobilier-durable-et-innovant/"
        },
        {
          title: "Phoenix Browser - Article complet",
          url: "https://phoenix-browser.com/KnXgzD65dN"
        },
        {
          title: "Facebook - EKIP Holding annonce la reconnaissance",
          url: "https://www.facebook.com/share/p/1D6v9wTkgb/?mibextid=wwXIfr"
        },
        {
          title: "Afrik Express - Ouagnimin Sorho sacré au Grand Prix Résilience",
          url: "https://afrikexpress.info/yamoussoukro-ouagnimin-sorho-sacre-au-grand-prix-resilience-et-durabilite-2025/"
        },
        {
          title: "Afrik Soir - Grand Prix Life Builders 2025",
          url: "https://afriksoir.net/grand-prix-life-builders-2025-ouagnimin-sorho-meilleure-entreprise-gestion-immobiliere/"
        },
        {
          title: "Info Centrale - Ouagnimin Sorho sacré meilleure entreprise",
          url: "https://infocentrale.net/2025/07/11/cote-divoire-ouagnimin-sorho-sacre-meilleure-entreprise-de-gestion-immobiliere-au-grand-prix-resilience-et-durabilite-2025/"
        }
      ],
      description: "Ouagnimin Sorho, PDG de KIDH Immobilier, a reçu le prix de la « Meilleure entreprise de gestion immobilière » lors de la 8ᵉ édition du Grand Prix Résilience et Durabilité de Life Builders. Cette reconnaissance prestigieuse récompense neuf personnalités du monde des affaires et des immobiliers dans un secteur en pleine mutation."
    },
    {
      id: 2,
      title: "Acquisition de la Licence de Distribution Exclusive de la Marque WAYNE en Côte d'Ivoire",
      date: "28 Juillet 2025",
      category: "Partenariat Stratégique",
      icon: Building,
      color: "#FF6600",
      image: "https://customer-assets.emergentagent.com/job_ekip-showcase/artifacts/30lwa9ee_Licence%20Wayne%20CI.png",
      pressRelease: null,
      pressArticles: [],
      onlineArticles: [],
      description: "La Holding EKIP annonce que son entité Kip Energy a acquis la licence de distribution exclusive de l'ensemble des produits de la marque WAYNE en Côte d'Ivoire. Cette licence couvre la distribution de carburant, les lubrifiants, fluides et produits automobiles, ainsi que les projets structurants du secteur énergétique."
    },
    {
      id: 3,
      title: "EKIP Holding Clôture 2025 par des Reconnaissances Majeures et Dévoile sa Vision Stratégique 2026",
      date: "31 Décembre 2025",
      category: "Bilan Annuel",
      icon: Award,
      color: "#00A651",
      image: "https://customer-assets.emergentagent.com/job_ekip-showcase/artifacts/hb9qbu3j_Cloture%202025.png",
      pressRelease: null,
      pressArticles: [],
      onlineArticles: [],
      description: "Le groupe ivoirien consolide son positionnement d'écosystème intégré et lance un appel aux investisseurs. L'année 2025 restera marquée par plusieurs reconnaissances majeures confirmant le leadership d'EKIP Holding dans le paysage économique ivoirien, notamment le Grand Prix de la Meilleure Entreprise Immobilière et l'admission au Board de la Chambre Nationale des Constructeurs."
    },
    {
      id: 4,
      title: "Nomination de KIPYZ Design & Houses au Secrétariat Général de la CNPC-CI",
      date: "25 Novembre 2025",
      category: "Gouvernance",
      icon: Briefcase,
      color: "#003366",
      image: "https://customer-assets.emergentagent.com/job_ekip-showcase/artifacts/rwij97of_KIDH_C002.png",
      pressRelease: null,
      pressArticles: [],
      onlineArticles: [],
      description: "La holding EKIP annonce la nomination de son entité Kipyz Design & Houses (KIDH) au poste de Secrétariat Général Adjoint, en charge des relations avec les organisations, des affaires sociales et de la promotion au sein de la Chambre Nationale des Promoteurs et des Constructeurs Immobiliers Agréés de Côte d'Ivoire (CNPC-CI)."
    }
  ];

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#003366] to-[#004080]">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Actualités
          </h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Suivez les dernières nouvelles et réalisations du groupe EKIP Holding
          </p>
        </div>
      </section>

      {/* News Grid */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto space-y-16">
          {news.map((item) => {
            const Icon = item.icon;
            return (
              <Card key={item.id} className="border-2 shadow-xl overflow-hidden" style={{ borderColor: item.color }}>
                <CardContent className="p-0">
                  {/* Header */}
                  <div className="p-8 pb-6" style={{ background: `linear-gradient(135deg, ${item.color}15, ${item.color}05)` }}>
                    <div className="flex items-start justify-between mb-4">
                      <div className="flex-1">
                        <Badge className="mb-3" style={{ backgroundColor: item.color }}>
                          {item.category}
                        </Badge>
                        <h2 className="text-3xl font-bold text-[#003366] mb-4">{item.title}</h2>
                        <div className="flex items-center space-x-2 text-gray-600">
                          <Calendar size={18} />
                          <span className="font-medium">{item.date}</span>
                        </div>
                      </div>
                      <div className="p-4 rounded-lg ml-4" style={{ backgroundColor: item.color }}>
                        <Icon className="text-white" size={32} />
                      </div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-8">
                    <p className="text-lg text-gray-700 leading-relaxed mb-8">
                      {item.description}
                    </p>

                    {/* Main Image */}
                    {item.image && (
                      <div className="mb-8">
                        <img 
                          src={item.image} 
                          alt={item.title}
                          className="w-full rounded-lg shadow-lg"
                        />
                      </div>
                    )}

                    {/* Press Release */}
                    {item.pressRelease && (
                      <div className="mb-8">
                        <h3 className="text-xl font-bold text-[#003366] mb-4 flex items-center">
                          <Users className="mr-2" style={{ color: item.color }} size={24} />
                          Communiqué de Presse
                        </h3>
                        <Card className="border-2" style={{ borderColor: item.color }}>
                          <CardContent className="p-4">
                            <img 
                              src={item.pressRelease} 
                              alt="Communiqué de presse"
                              className="w-full rounded"
                            />
                          </CardContent>
                        </Card>
                      </div>
                    )}

                    {/* Press Articles */}
                    {item.pressArticles && item.pressArticles.length > 0 && (
                      <div className="mb-8">
                        <h3 className="text-xl font-bold text-[#003366] mb-4">
                          Articles de Presse
                        </h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                          {item.pressArticles.map((article, index) => (
                            <Card key={index} className="border-2" style={{ borderColor: item.color }}>
                              <CardContent className="p-4">
                                <h4 className="font-semibold text-[#003366] mb-3">{article.title}</h4>
                                <img 
                                  src={article.image} 
                                  alt={article.title}
                                  className="w-full rounded shadow-md"
                                />
                              </CardContent>
                            </Card>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Online Articles */}
                    {item.onlineArticles && item.onlineArticles.length > 0 && (
                      <div>
                        <h3 className="text-xl font-bold text-[#003366] mb-4">
                          Articles en Ligne
                        </h3>
                        <div className="space-y-3">
                          {item.onlineArticles.map((article, index) => (
                            <a
                              key={index}
                              href={article.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="flex items-center justify-between p-4 border-2 rounded-lg hover:shadow-lg transition-all duration-200 group"
                              style={{ borderColor: `${item.color}40` }}
                            >
                              <span className="font-medium text-gray-700 group-hover:text-[#FF6600]">
                                {article.title}
                              </span>
                              <ExternalLink 
                                className="text-gray-400 group-hover:text-[#FF6600] transition-colors" 
                                size={20} 
                              />
                            </a>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </section>
    </div>
  );
};
